import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

@Component({
	selector: 'app-common-symbol-stylepicker',
	templateUrl: './common-symbol-stylepicker.component.html',
	styleUrls: ['./common-symbol-stylepicker.component.css']
})
export class CommonSymbolStylepickerComponent implements OnInit {

	@Input() color = 'black'; // The color to use on styles // eg. '#efefef'
	@Input() selectedSize: number;
	@Input() selectedShape: string;
	@Output() styleChange: EventEmitter<{size: number; shape: string; }> = new EventEmitter();

	public showStyleBoard: boolean;
	public sizes: number[] = [1, 2, 3, 4, 5];
	public shapes: string[] = ['LNS', 'CIR', 'SQR', 'DIA', 'TRI'];
	constructor(
		private elemRef: ElementRef
	) { }

	@HostListener('document:click', ['$event'])
	onDocumentClick(e: MouseEvent) {
		if (e.target && !this.elemRef.nativeElement.contains(e.target)) {
			this.toggleStyleBoard(false);
		}
	}


	toggleStyleBoard(isShow: boolean) {
		this.showStyleBoard = isShow;
	}
	pickSizedStyle(shape: string, size: number) {
		this.selectedShape = shape;
		this.selectedSize = size;
		this.toggleStyleBoard(false);
		this.styleChange.next({
			size: this.selectedSize,
			shape: this.selectedShape
		});
	}

	ngOnInit() {
		debugger
		// If Default style is set and user doesn't apply it, it will cause problem
		// // Set default style
		// this.selectedShape = this.selectedShape || this.shapes[1]; // CIR
		// // Set default size
		// this.selectedSize = this.selectedSize || this.sizes[2]; // 3
		// this.styleChange.next({
		// 	size: this.selectedSize,
		// 	shape: this.selectedShape
		// });
	}

}



// WEBPACK FOOTER //
// ./src/app/components/common-symbol-stylepicker/common-symbol-stylepicker.component.ts